<template>
  <div class="form-title">
    <app-i18n
      tag="p"
      :code="titleI18nCode"
    />
    <app-separator class="form-title__separator" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AppSeparator from '@/components/Separator.vue'

export default {
  name: 'appFormTitle',
  computed: {
    ...mapState('form', ['currentStep']),
    titleI18nCode() {
      return `teamRegistrationSite.form.step${this.currentStep}.title`
    },
  },
  components: {
    AppSeparator,
  },
}
</script>

<style lang="scss" scoped>
.form-title {
  text-align: center;
  text-transform: uppercase;
  font-size: 18px;

  &__separator.separator {
    margin-top: 16px;
  }
}
</style>
